var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorPalater = function SvgColorPalater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 3.833A6.676 6.676 0 0 0 3.333 10.5 6.675 6.675 0 0 0 10 17.166a.413.413 0 0 0 .417-.416.45.45 0 0 0-.117-.292 2.07 2.07 0 0 1-.525-1.375c0-1.15.933-2.083 2.083-2.083h1.475a3.33 3.33 0 0 0 3.334-3.334c0-3.216-2.992-5.833-6.667-5.833m-4.583 7.5c-.692 0-1.25-.558-1.25-1.25s.558-1.25 1.25-1.25c.691 0 1.25.558 1.25 1.25s-.559 1.25-1.25 1.25m1.25-4.583c0 .691.558 1.25 1.25 1.25.691 0 1.25-.559 1.25-1.25 0-.692-.559-1.25-1.25-1.25-.692 0-1.25.558-1.25 1.25M12.083 8c-.691 0-1.25-.559-1.25-1.25 0-.692.559-1.25 1.25-1.25.692 0 1.25.558 1.25 1.25 0 .691-.558 1.25-1.25 1.25m2.5 3.333c.692 0 1.25-.558 1.25-1.25s-.558-1.25-1.25-1.25c-.691 0-1.25.558-1.25 1.25s.559 1.25 1.25 1.25",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#color-palater_svg__a)",
    d: "M10 2.167c-4.592 0-8.333 3.742-8.333 8.333S5.408 18.834 10 18.834a2.084 2.084 0 0 0 1.55-3.475.413.413 0 0 1 .308-.692h1.475c2.759 0 5-2.242 5-5 0-4.133-3.741-7.5-8.333-7.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.417 11.333a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M7.917 8a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M12.083 8a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M14.583 11.333a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "color-palater_svg__a",
    x1: 10,
    x2: 10,
    y1: 2.167,
    y2: 18.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6711F2"
  })))));
};
export default SvgColorPalater;